<template>
  <div class="row q-col-gutter-lg">
    <div class="col-12 col-sm-6">
      <a
        :href="enUrl"
        target="_blank"
        style="color: unset"
      >
        <q-btn
          label="Step by Step Instructions (English)"
          class="full-width"
          unelevated
          rounded
          outline
          no-caps
        />
      </a>
    </div>
    <div class="col-12 col-sm-6">
      <a
        :href="esUrl"
        target="_blank"
        style="color: unset"
      >
        <q-btn
          label="Step by Step Instructions (Spanish)"
          class="full-width"
          unelevated
          outline
          rounded
          no-caps
        />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { types as platforms } from '@/social/site';

interface Urls {
  [platform: string]: {
    en: string;
    es: string;
  };
}

const urls:Urls = {};
urls[platforms.Facebook] = {
  en: 'https://scribehow.com/viewer/How_to_import_your_Facebook_posts_to_PrivateFootprint__ynGKAbZ-QXCUB5KeoXNSDQ',
  es: 'https://scribehow.com/viewer/Como_importar_sus_publicaciones_de_Facebook_a_Private_Footprint__-AQlzOr7S1ezhLmQO8N8dA',
};
urls[platforms.Instagram] = {
  en: 'https://scribehow.com/viewer/How_to_import_your_Instagram_posts_to_Private_Footprint__DeaHZqIzQNuNW-qN2UDARg',
  es: 'https://scribehow.com/viewer/Como_importar_sus_publicaciones_de_Instagram_a_Private_Footprint__-_C1_ToIQNylfclUEoIISQ',
};
urls[platforms.TikTok] = {
  en: 'https://scribehow.com/viewer/How_to_import_your_TikTok_posts_to_PrivateFootprint__SxLc_uTAR7WxOgI_kTdOCw',
  es: 'https://scribehow.com/viewer/Como_importar_sus_publicaciones_de_TikTok_a_Private_Footprint__xG34OnmaQ1WIhRCJAQ_4Xw',
};
urls[platforms.Twitter] = {
  en: 'https://scribehow.com/viewer/How_to_import_your_X_Twitter_posts_to_PrivateFootprint__0zCFIvPASR-3YlnIZ7Elpg',
  es: 'https://scribehow.com/viewer/Como_importar_sus_publicaciones_de_X_Twitter_a_Private_Footprint__62hDORAxSvuYMUEw2r_HAg',
};
urls[platforms.YouTube] = {
  en: 'https://scribehow.com/viewer/How_to_import_your_YouTube_posts_to_PrivateFootprint__RxZvhcOgRE633W2ZxTsHQQ',
  es: 'https://scribehow.com/viewer/Como_importar_sus_publicaciones_de_YouTube_a_Private_Footprint__Xh-GX7RyShSyl5zb0dN0Pg',
};

export default defineComponent({
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  computed: {
    enUrl(): string {
      return urls[this.platform].en;
    },
    esUrl(): string {
      return urls[this.platform].es;
    },
  },
});
</script>
